import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { useSelector } from "react-redux";
import { handleDetailResponse, seo } from "utils/utils";
import VideoModel from "component/common/videoModel";
import ImageRender from "component/common/ImageRender";
import Breadcrumb from "component/common/breadcrumb";

const ViewSupportForumGallary = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [baseUrl, setBaseUrl] = useState("");
  const { support_forum_id = "", doc_type = "image" } = params || {};

  const [supportForumDetail, setSupportForumDetail] = useState([]);
  const [videoDetails, setVideoDetails] = useState(null);

  const supportForumDetailSelector =
    useSelector((state) => state.supportForum) || {};

  useEffect(() => {
    const { response = null } = supportForumDetailSelector;
    if (response) {
      setSupportForumDetail(
        handleDetailResponse(response?.data)?.support_forum_content.filter(
          (item) => item.content_type === doc_type
        ) || []
      );
      setBaseUrl(handleDetailResponse(response.data).base_url);
    }
  }, [supportForumDetailSelector]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    seo({
      title: "Support Forum Image Gallary",
      metaDescription: "support forum image gallary",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.gallery}
        parentListing={null}
        titleactive={strings.gallery}
        isBackBtn={true}
      />
      <VideoModel data={videoDetails} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card row">
              <div className="card-header">
                <div className="col-sm-12 row">
                  <h5 className="col-sm-10">{strings.gallery}</h5>
                </div>
              </div>
              <div className="my-gallery card-body row" itemScope="">
                {supportForumDetail &&
                  supportForumDetail.map((item, i) =>
                    doc_type === "image" ? (
                      <ImageRender
                        key={i}
                        isGallery={true}
                        baseUrl={baseUrl}
                        imageUrl={item.content}
                        thumbnailUrl={item.content}
                      />
                    ) : doc_type === "video" ? (
                      <div className="col-md-3">
                        <img
                          key={i}
                          src={baseUrl + item.video_thumbnail}
                          className="img-thumbnail"
                          style={{
                            position: "relative",
                          }}
                        />
                        <i
                          className="fa fa-play theme-fa-icon"
                          style={{
                            position: "absolute",
                            right: "107px",
                            top: "52px",
                            fontSize: "xx-large",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                          data-toggle="modal"
                          data-original-title="test"
                          data-target="#exampleModal"
                          onClick={() => {
                            item.base_url = baseUrl;
                            item.document = item.content;
                            setVideoDetails(item);
                          }}
                        ></i>
                      </div>
                    ) : doc_type === "content" ? (
                      <a
                        key={i}
                        href={baseUrl + item.content}
                        target={"_blank"}
                      >
                        <img
                          src="/assets/images/documentIcon.png"
                          className="img-fluid view_pro"
                        />
                      </a>
                    ) : (
                      <img
                        className="img-thumbnail"
                        src={"/assets/images/big-lightgallry/013.jpg"}
                      />
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSupportForumGallary;
